import { connect } from 'react-redux';

import LearningAdminModuleFormStep1 from '../components/LearningAdminModuleFormStep1';
import storage from '../../../../../lib/Storage';
import { List } from 'immutable';
import {
  loadModuleAdmin,
  updateModuleAdmin,
  createModuleAdmin,
  deleteModuleAdmin,
  moduleAdminFormDestroy,
} from '../../../../../state/modules/learningsAdmin/actions';

import {
  getImageUploadURL,
  uploadImage,
  createMediaImagePartnership,
  getImageSignedURL,
} from '../../../../../state/modules/media/actions';
import { findStorageType } from '../../../../../lib/Auth';

const inputs = List([
  'title',
  'description',
  'cover_image',
  'cover_image_id',
  'media',
  'media_id',
  'content',
  'categories',
  'order',
  'video_vimeo_url',
  'video_youtube_url',
  'module_serie_id',
  'public_status',
]);

const mapStateToProps = (state, ownProps) => {
  const data = {},
    errors = {};
  for (const val of inputs.values()) {
    data[val] = state.entities.getIn(
      ['learningModulesAdmin', ownProps.id, val],
      ''
    );
    errors[val] = state.learningsAdmin.getIn(['form', 'errors', val]);
  }

  data['public_status'] = data['public_status'] ? data['public_status'] : 2;

  return {
    isLoading:
      state.learningsAdmin.get('isLoading') ||
      state.media.get('isImageUploadUrlLoading') ||
      state.media.get('isImageUploading'),
    isSubmitting:
      state.learningsAdmin.getIn(['form', 'isSubmitting']) ||
      state.media.get('isSubmitting') ||
      state.media.getIn(['form', 'isSubmitting']),
    data: data,
    errors: errors,
    success: state.learningsAdmin.getIn(['form', 'success']),
    created_id: state.learningsAdmin.getIn(['form', 'created_id']),
    partnershipId: storage.get(findStorageType(), 'partnershipId'),
    partnershipName: storage.get(findStorageType(), 'partnershipName'),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    load: (partnershipId, id, cb) => {
      dispatch(loadModuleAdmin(partnershipId, id, cb));
    },
    update: (id, data, cb) => {
      dispatch(updateModuleAdmin(id, data, cb));
    },
    create: (data, cb) => {
      dispatch(createModuleAdmin(data, cb));
    },
    destroyForm: (formState) => {
      dispatch(moduleAdminFormDestroy(formState));
    },
    createImagePartnership: (partnershipId, data, cb) => {
      dispatch(createMediaImagePartnership(partnershipId, data, cb));
    },
    getUploadUrl: (extension, directory, cb) => {
      dispatch(getImageUploadURL(extension, directory, cb));
    },
    upload: (path, file, cb) => {
      dispatch(uploadImage(path, file, cb));
    },
    getSignedUrl: (path, cb) => {
      dispatch(getImageSignedURL(path, cb));
    },
    remove: (partnershipId, id, cb) => {
      dispatch(deleteModuleAdmin(partnershipId, id, cb));
    },
  };
};

const LearningAdminModuleFormStep1Container = connect(
  mapStateToProps,
  mapDispatchToProps
)(LearningAdminModuleFormStep1);

export default LearningAdminModuleFormStep1Container;
